/* MAY HOME — Çekmeceler: menü, arama, favoriler, hesap, sepet */
(function () {
  var FAV_KEY = 'mh-favorites';
  var overlay = document.querySelector('[data-drawer-overlay]');

  /* ---------- aç / kapa ---------- */
  function drawer(name) { return document.querySelector('.mh-drawer[data-drawer="' + name + '"]'); }

  function open(name) {
    var d = drawer(name);
    if (!d || !overlay) return;
    document.querySelectorAll('.mh-drawer.is-open').forEach(function (x) { if (x !== d) { x.classList.remove('is-open'); x.setAttribute('aria-hidden', 'true'); } });
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); d.classList.add('is-open'); });
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mh-drawer-open');
    if (name === 'cart') refreshCart();
    if (name === 'favorites') { renderFav(); renderFavCoupons(); }
    if (name === 'search') { var i = d.querySelector('[data-search-input]'); if (i) setTimeout(function () { i.focus(); }, 320); }
  }

  function closeAll() {
    document.querySelectorAll('.mh-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { if (!document.querySelector('.mh-drawer.is-open')) overlay.hidden = true; }, 340); }
    document.body.classList.remove('mh-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- para biçimi ---------- */
  function money(cents) {
    var v = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return v + ' ₺';
  }

  /* ---------- SEPET ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('.mh-cart__count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
      if (count) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }

  function readJSON(id) { try { var el = document.getElementById(id); var v = el ? JSON.parse(el.textContent) : []; return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function getCoupons() {
    var list = readJSON('mh-cart-coupons');
    if (!list.length) list = readJSON('mh-product-coupons');
    if (!list.length) { try { list = JSON.parse(localStorage.getItem('mh-coupons-cache') || '[]'); } catch (e) { list = []; } }
    return list.filter(function (c) { return c && c.code; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function parseTL(v) { var d = String(v || '').replace(/[^0-9,\.]/g, ''); if (!d) return 0; d = d.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'); return Math.round(parseFloat(d) * 100) || 0; }
  function tl(c) { return (c / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL'; }
  function couponsHTML(cart) {
    var list = getCoupons(); if (!list.length) return '';
    var used = {}; (cart && cart.discount_codes || []).forEach(function (d) { used[d.code.toLowerCase()] = d.applicable ? 'ok' : 'off'; });
    var total = cart ? cart.total_price + ((cart.original_total_price || cart.total_price) - cart.total_price) : 0;
    var drawer = document.querySelector('[data-drawer="cart"]');
    var heading = (drawer && drawer.getAttribute('data-coupon-heading')) || 'Kuponlar';
    return '<div class="mh-coupons mh-coupons--drawer" data-coupons>' +
      '<div class="mh-coupons__head"><div class="mh-coupons__title"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg><span>' + esc(heading) + '</span></div>' +
      (list.length > 1 ? '<div class="mh-coupons__nav"><button type="button" data-cp-step="-1" aria-label="Önceki">‹</button><button type="button" data-cp-step="1" aria-label="Sonraki">›</button></div>' : '') +
      '</div><div class="mh-coupons__track" data-cp-track>' + list.map(function (c) {
        var st = used[String(c.code).toLowerCase()];
        var min = parseTL(c.min), left = min - total;
        var info;
        if (st === 'ok') info = '<div class="mh-coupon__info is-ok">Kupon uygulandı</div>';
        else if (min && left > 0) info = '<div class="mh-coupon__info">Sepete <b>' + tl(left) + '</b> daha ekleyin</div>';
        else if (min) info = '<div class="mh-coupon__info is-ok">' + tl(min) + ' ve üzeri · Kullanılabilir</div>';
        else info = '<div class="mh-coupon__info is-ok">Tüm siparişlerde geçerli</div>';
        var btn = st === 'ok' ? '<button type="button" class="mh-coupon__btn is-done" disabled>Uygulandı ✓</button>'
          : '<button type="button" class="mh-coupon__btn" data-dcoupon="' + esc(c.code) + '">Kazan</button>';
        return '<div class="mh-coupon">' +
          '<div class="mh-coupon__left"><div class="mh-coupon__amount">' + esc(c.amount) + '</div>' + btn + '</div>' +
          '<div class="mh-coupon__right">' + info + (c.end ? '<div class="mh-coupon__date">Son gün ' + esc(c.end) + '</div>' : '') + '</div>' +
        '</div>';
      }).join('') + '</div></div>';
  }
  async function renderFavCoupons() {
    var box = document.querySelector('[data-fav-coupons]'); if (!box) return;
    var cart = null;
    try { cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); } catch (x) {}
    box.innerHTML = couponsHTML(cart);
  }

  async function refreshCart() {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    var cart;
    try { cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    catch (e) { body.innerHTML = '<div class="mh-drawer__empty">Sepet yüklenemedi.</div>'; return; }
    updateCartCount(cart.item_count);
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="mh-drawer__empty"><svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg><div>Sepetiniz henüz boş.</div></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      return '<div class="mh-drow" data-key="' + it.key + '">' +
        '<a class="mh-drow__media" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</a>' +
        '<div class="mh-drow__info">' +
          '<a class="mh-drow__title" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="mh-drow__meta">' + it.variant_title + '</div>' : '') +
          '<div class="mh-qty" data-key="' + it.key + '"><button type="button" data-delta="-1">−</button><span>' + it.quantity + '</span><button type="button" data-delta="1">+</button></div>' +
          '<div class="mh-drow__price">' + money(it.final_line_price) + '</div>' +
        '</div>' +
        '<button class="mh-drow__x" type="button" data-remove="' + it.key + '" aria-label="Kaldır">×</button>' +
      '</div>';
    }).join('') + couponsHTML(cart);
    if (foot) {
      foot.hidden = false;
      var codes = cart.discount_codes || [];
      var saved = (cart.original_total_price || cart.total_price) - cart.total_price;
      var chips = codes.map(function (d) {
        return '<span class="mh-dcode' + (d.applicable ? '' : ' is-off') + '">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>' +
          d.code + (d.applicable ? '' : ' · alt limit') +
          '<button type="button" data-dremove="' + d.code + '" aria-label="Kaldır">×</button></span>';
      }).join('');
      foot.innerHTML =
        '<form class="mh-dform" data-dform><input type="text" name="code" placeholder="İndirim kodu" autocomplete="off"><button type="submit">Uygula</button></form>' +
        '<div class="mh-dform__msg" data-dmsg></div>' +
        (chips ? '<div class="mh-dcodes">' + chips + '</div>' : '') +
        (saved > 0 ? '<div class="mh-cartdrawer__sub"><span>Ürünler</span><span>' + money(cart.original_total_price) + '</span></div>' +
                     '<div class="mh-cartdrawer__sub mh-cartdrawer__disc"><span>İndirim</span><span>−' + money(saved) + '</span></div>' : '') +
        '<div class="mh-cartdrawer__sub mh-cartdrawer__grand"><span>Toplam</span><span>' + money(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="mh-btn">Ödemeye geç</a>' +
        '<a href="/cart" class="mh-cartdrawer__view">Sepeti görüntüle</a>';
    }
  }

  async function changeCart(key, qty) {
    try {
      var cart = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
      updateCartCount(cart.item_count);
      refreshCart();
    } catch (e) { refreshCart(); }
  }

  document.addEventListener('submit', async function (e) {
    var f = e.target.closest && e.target.closest('[data-dform]');
    if (!f || !window.MHDiscount) return;
    e.preventDefault();
    var input = f.querySelector('input'); var btn = f.querySelector('button');
    var code = input.value.trim(); if (!code) return;
    btn.disabled = true; btn.textContent = '…';
    var r = await window.MHDiscount.apply(code);
    var m = document.querySelector('[data-dmsg]');
    if (m) { m.textContent = r === 'applied' ? '' : window.MHDiscount.msg(r); }
    btn.disabled = false; btn.textContent = 'Uygula';
  });

  document.addEventListener('click', async function (e) {
    var cs = e.target.closest('[data-cp-step]');
    if (cs) { var tr = cs.closest('[data-coupons]').querySelector('[data-cp-track]'); var cc = tr.querySelector('.mh-coupon'); tr.scrollBy({ left: Number(cs.getAttribute('data-cp-step')) * ((cc ? cc.offsetWidth : 260) + 14), behavior: 'smooth' }); return; }
    var dc = e.target.closest('[data-dcoupon]');
    if (dc && window.MHDiscount) {
      dc.disabled = true; dc.textContent = '…';
      var r = await window.MHDiscount.apply(dc.getAttribute('data-dcoupon'));
      if (r !== 'applied') { var m = document.querySelector('[data-dmsg]'); if (m) m.textContent = window.MHDiscount.msg(r); }
      refreshCart(); renderFavCoupons();
      return;
    }
    var dr = e.target.closest('[data-dremove]');
    if (dr && window.MHDiscount) { window.MHDiscount.remove(dr.getAttribute('data-dremove')); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeCart(rm.getAttribute('data-remove'), 0); return; }
    var q = e.target.closest('.mh-qty button');
    if (q) {
      var wrap = q.closest('.mh-qty');
      var cur = parseInt(wrap.querySelector('span').textContent, 10) || 1;
      var next = cur + parseInt(q.getAttribute('data-delta'), 10);
      if (next < 0) next = 0;
      changeCart(wrap.getAttribute('data-key'), next);
    }
  });

  /* ---------- FAVORİLER ---------- */
  function getFav() { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; } }
  function setFav(list) { localStorage.setItem(FAV_KEY, JSON.stringify(list)); updateFavCount(); syncHearts(); }
  function updateFavCount() {
    var n = getFav().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-empty', !n);
      if (n) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  function syncHearts() {
    var handles = getFav().map(function (f) { return f.handle; });
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      b.classList.toggle('is-on', handles.indexOf(b.getAttribute('data-handle')) > -1);
    });
  }
  function renderFav() {
    var box = document.querySelector('[data-fav-list]');
    if (!box) return;
    var list = getFav();
    if (!list.length) {
      box.innerHTML = '<div class="mh-drawer__empty"><svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"></path></svg><div>Henüz favoriniz yok.<br>Beğendiğiniz ürünlerdeki kalbe dokunun.</div></div>';
      return;
    }
    box.innerHTML = list.map(function (f) {
      return '<div class="mh-drow" data-handle="' + f.handle + '">' +
        '<a class="mh-drow__media" href="' + f.url + '">' + (f.image ? '<img src="' + f.image + '" alt="">' : '') + '</a>' +
        '<div class="mh-drow__info">' +
          '<a class="mh-drow__title" href="' + f.url + '">' + f.title + '</a>' +
          '<div class="mh-drow__price">' + (f.price || '') + '</div>' +
        '</div>' +
        '<button class="mh-drow__x" type="button" data-fav-remove="' + f.handle + '" aria-label="Kaldır">×</button>' +
      '</div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-fav]');
    if (heart) {
      e.preventDefault(); e.stopPropagation();
      var handle = heart.getAttribute('data-handle');
      var list = getFav();
      var idx = list.findIndex(function (f) { return f.handle === handle; });
      if (idx > -1) { list.splice(idx, 1); }
      else {
        list.push({
          handle: handle,
          title: heart.getAttribute('data-title'),
          url: heart.getAttribute('data-url'),
          image: heart.getAttribute('data-image'),
          price: heart.getAttribute('data-price')
        });
      }
      setFav(list);
      renderFav();
      return;
    }
    var fr = e.target.closest('[data-fav-remove]');
    if (fr) {
      var h = fr.getAttribute('data-fav-remove');
      setFav(getFav().filter(function (f) { return f.handle !== h; }));
      renderFav();
    }
  });

  /* ---------- başlangıç ---------- */
  updateFavCount();
  syncHearts();

  window.MHDrawers = { open: open, close: closeAll, refreshCart: refreshCart, openCart: function () { open('cart'); } };
})();
